export const getters = {
  userInfo: state => state.userInfo,
  jwt: state => state.jwt,
  userIsLoggedIn: state => state.userIsLoggedIn
}

export default getters



// WEBPACK FOOTER //
// ./src/store/module/auth/getters.js